import { useReportingToolsStore } from '../../store/useReportingToolsStore';

export const DesktopPreferedBox = () => {
  const page = useReportingToolsStore((state) => state.page);
  const box = page?.desktopPreferedBox;
  if (!box) return null;

  return (
    <div role="note" className="mt-4 rounded-2xl border border-blue-100 bg-blue-50 px-5 py-5 shadow-sm md:hidden">
      <p className="text-sh-xs font-bold leading-8 text-black-100">{box?.title}</p>

      <p className="mt-2 text-sh-xs text-black">{box?.description}</p>
    </div>
  );
};
